import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useI18n } from '../../context/occ/hooks/use-i18n';
import { useOccConfig } from '../../context/occ/hooks/use-occ-config';
import { Carousel } from '../carousel/carousel';
import { DatePickerDate } from './subcomponents/date';
import { DatePickerSkeleton } from './subcomponents/skeleton';
import { getDatePickerDateValues } from './utils';
const b = bemClassBuilder('v-date-picker');
export const DatePicker = observer(props => {
    const i18n = useI18n();
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const { isLoading, businessDates, selectedBusinessDate, onDateClicked, dateFormat, todayDateFormat, dateExternallyClicked, carouselConfig } = props;
    const values = getDatePickerDateValues(businessDates, selectedBusinessDate, i18n);
    const [scrollToSlide, setScrollToSlide] = useState(0);
    // Scroll an externally clicked date into view.
    useEffect(() => {
        if (!dateExternallyClicked)
            return;
        const index = values.findIndex(v => v.businessDate === selectedBusinessDate);
        setScrollToSlide(index + 1);
    }, [dateExternallyClicked, selectedBusinessDate, values]);
    if (isLoading)
        return enableSkeletonLoadingIndicators ? _jsx(DatePickerSkeleton, {}) : null;
    return (_jsx("div", Object.assign({ className: b.block() }, { children: _jsx(Carousel, Object.assign({ config: Object.assign(Object.assign({}, carouselConfig), { scrollToSlide }) }, { children: values.map(value => (_jsx(DatePickerDate, { value: value, onClick: onDateClicked, dateFormat: value.isToday ? todayDateFormat : dateFormat }, value.businessDate))) })) })));
});
DatePicker.displayName = 'DatePicker';
